export const ITEMS_QUERY_KEYS = {
    bookmarks: 'bookmarks-items',
    companies: {
        items: 'companies-items',
        jobs: {
            items: (id) => `company-jobs-items-${id}`,
            pinnedItems: (id) => `company-jobs-pinned-items-${id}`,
        },
        people: {
            current: (id) => `companies-current-users-${id}`,
            past: (id) => `companies-past-users-${id}`,
        },
    },
    donations: {
        tags: 'donations-tags',
        items: 'donations-items',
    },
    forum: {
        tags: 'forum-tags',
        items: 'forum-items',
        pinnedItems: 'forum-pinned-item',
        side: 'forum-widgets',
    },
    jobs: {
        tags: 'jobs-tags',
        items: 'jobs-items',
        pinnedItems: 'jobs-pinned-items',
    },
    mediacenter: {
        files: 'mediacenter-files-items',
        folders: 'mediacenter-folders-items',
    },
    news: {
        tags: 'news-tags',
        items: 'news-items',
        pinnedItems: 'news-slider-items',
    },
    notifications: 'notifications-items',
    portfolios: 'portfolios-items',
    projects: 'projects-items',
    mentoring: {
        items: (id) => `mentoring-items-${id}`,
    },
    myMentoring: {
        items: 'my-mentoring-items',
        mentors: (id) => `mentoring-mentors-${id}`,
        mentees: (id) => `mentoring-mentees-${id}`,
    },
};
export const getNextCursorPageParam = (lastPage) => (lastPage.hasNextPage ? lastPage.endCursor : undefined);
export const getNextPageParam = (lastPage, pages) => {
    var _a;
    const totalItems = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.totalItems) !== null && _a !== void 0 ? _a : 0;
    if (!lastPage || totalItems === 0) {
        return undefined;
    }
    const currentTotalItems = pages.reduce((acc, page) => { var _a, _b; return acc + ((_b = (_a = page === null || page === void 0 ? void 0 : page.items) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); }, 0);
    return currentTotalItems < totalItems ? pages.length + 1 : undefined;
};
//# sourceMappingURL=queryUtils.js.map